import { ReportScreen } from "@/screens";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const reportsSearchSchema = z.object({
  startDate: z.string().optional().catch(undefined),
  endDate: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/dashboard/reports/")({
  component: ReportScreen,
  validateSearch: reportsSearchSchema,
  loaderDeps: (opts) => ({ ...opts.search }),
  loader: async () => {
    return {
      crumb: "Laporan",
    };
  },
});